import React, { useEffect } from 'react';
import { useLocation, Link } from 'react-router-dom';
import { useTranslation } from '../hooks/useTranslation';
import { NavigateNext } from '../mui-icons';
import './SEOBreadcrumbs.css';

// Mapeamento de rotas para nomes de páginas
const routeNames = {
  '/': { pt: 'Início', en: 'Home', es: 'Inicio' },
  '/about': { pt: 'Sobre', en: 'About', es: 'Acerca de' },
  '/plans': { pt: 'Planos', en: 'Plans', es: 'Planes' },
  '/nutrition': { pt: 'Análise Nutricional', en: 'Nutritional Analysis', es: 'Análisis Nutricional' },
  '/support': { pt: 'Suporte', en: 'Support', es: 'Soporte' },
  '/partnerships': { pt: 'Parcerias', en: 'Partnerships', es: 'Asociaciones' },
  '/privacy': { pt: 'Privacidade', en: 'Privacy', es: 'Privacidad' },
  '/terms': { pt: 'Termos de Uso', en: 'Terms of Use', es: 'Términos de Uso' },
  '/policy': { pt: 'Política', en: 'Policy', es: 'Política' },
  '/download': { pt: 'Download', en: 'Download', es: 'Descargar' },
};

const SEOBreadcrumbs = ({ showVisual = false }) => {
  const location = useLocation();
  const { currentLanguage } = useTranslation();
  
  // Não mostrar breadcrumbs na home
  if (location.pathname === '/') {
    return null;
  }

  // Gerar itens do breadcrumb
  const pathParts = location.pathname.split('/').filter(Boolean);
  const breadcrumbItems = [
    { path: '/', name: getRouteName('/', currentLanguage) }
  ];

  let currentPath = '';
  pathParts.forEach((part) => {
    currentPath += `/${part}`;
    const name = getRouteName(currentPath, currentLanguage);
    if (name) {
      breadcrumbItems.push({ path: currentPath, name });
    }
  });

  // Gerar JSON-LD para SEO
  const jsonLd = {
    "@context": "https://schema.org",
    "@type": "BreadcrumbList",
    "itemListElement": breadcrumbItems.map((item, index) => ({
      "@type": "ListItem",
      "position": index + 1,
      "name": item.name,
      "item": `https://personalnutri.app${item.path === '/' ? '' : item.path}`
    }))
  };

  return (
    <>
      {/* JSON-LD Schema para SEO */}
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(jsonLd) }}
      />
      
      {/* Breadcrumb Visual (opcional) */}
      {showVisual && (
        <nav aria-label="Breadcrumb" className="seo-breadcrumbs">
          <ol className="breadcrumb-list" itemScope itemType="https://schema.org/BreadcrumbList">
            {breadcrumbItems.map((item, index) => (
              <li 
                key={item.path} 
                className="breadcrumb-item"
                itemProp="itemListElement" 
                itemScope 
                itemType="https://schema.org/ListItem"
              >
                {index < breadcrumbItems.length - 1 ? (
                  <>
                    <Link 
                      to={item.path} 
                      itemProp="item"
                      className="breadcrumb-link"
                    >
                      <span itemProp="name">{item.name}</span>
                    </Link>
                    <NavigateNext className="breadcrumb-separator" />
                  </>
                ) : (
                  <span itemProp="name" className="breadcrumb-current">
                    {item.name}
                  </span>
                )}
                <meta itemProp="position" content={String(index + 1)} />
              </li>
            ))}
          </ol>
        </nav>
      )}
    </>
  );
};

// Função auxiliar para obter nome da rota
function getRouteName(path, language) {
  const route = routeNames[path];
  if (!route) return null;
  
  const langKey = language?.split('-')[0] || 'pt';
  return route[langKey] || route.pt;
}

export default SEOBreadcrumbs;

